import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useParams } from 'react-router'
import Producentarendetyp from '../../../model/producentarendetyp'
import Kundhandelsetyp from '../../../model/kundhandelsetyp'
import * as ProducentarendetypService from '../../../service/static/producentarendetypServiceStatic'
import * as KundhandelsetypService from '../../../service/static/kundhandelsetypServiceStatic'
import { useTable, useExpanded } from 'react-table'
import MyReactTable from '../../components/myReactTable'
import * as ImageHandler from '../../components/imageHandler'
import { ChevronDown, ChevronUp, CheckCircle,  ExclamationCircle} from 'react-bootstrap-icons'
import './showProducentarendetyp.scss'
import ShowKundhandelsetyp from "../../components/ShowKundhandelsetyp";
import BackToStart from "../../components/BackToStart";
import { useNavigate } from "react-router-dom";

const ShowProducentarendetyp = () => {
    let producentarendetypId = useParams().id
    const navigate = useNavigate()

    const [kundhandelsetyper, setKundhandelsetyper] = useState<Kundhandelsetyp[]>([])
    const [producentarendetyp, setProducentarendetyp] = useState<Producentarendetyp | undefined>(undefined)
    const [otherProducentarendetyper, setOtherProducentarendetyper] = useState<Producentarendetyp[]>([])
    const [showList, setShowList] = useState<boolean>(true)

    let fetchingKundhandelsetyper = useRef<boolean>(false)
    let fetchedKundhandelsetyper  = useRef<boolean>(false)
    let fetchingProducentarendetyp = useRef<boolean>(false)
    let fetchedProducentarendetyp  = useRef<boolean>(false)
    let fetchingOtherProducentarendetyper = useRef<boolean>(false)
    let fetchedOtherProducentarendetyper = useRef<boolean>(false)


    useEffect(fetchData)

    function fetchData() {
        const fetchKundhandelsetyper = async () => {
            fetchingKundhandelsetyper.current = true

            // @ts-ignore
            const localKundhandelsetyper = await KundhandelsetypService.getByProducentarendetypId(producentarendetypId)
            localKundhandelsetyper.sort((a: Kundhandelsetyp, b: Kundhandelsetyp) => {
                return a.namn.localeCompare(b.namn)
            })

            fetchedKundhandelsetyper.current = true
            fetchingKundhandelsetyper.current = false

            setKundhandelsetyper(localKundhandelsetyper)
        }

        const fetchProducentarendetyp = async () => {
            fetchingProducentarendetyp.current = true

            // @ts-ignore
            const localProducentarendetyp = await ProducentarendetypService.getById(producentarendetypId)

            fetchingProducentarendetyp.current = false
            fetchedProducentarendetyp.current = true

            setProducentarendetyp(localProducentarendetyp)
        }

        const fetchOtherProducentarendetyper = async () => {
            fetchingOtherProducentarendetyper.current = true

            // @ts-ignore
            const other: Producentarendetyp[] = await ProducentarendetypService.getByIdentifierare(producentarendetyp.identifierare)
            console.log(other)
            other.sort((a: Producentarendetyp, b:Producentarendetyp) => {
                return a.producent.namn.localeCompare(b.producent.namn)
            })
            fetchedOtherProducentarendetyper.current = true
            fetchingOtherProducentarendetyper.current = false

            setOtherProducentarendetyper(other)
        }

        if (!fetchingKundhandelsetyper.current && !fetchedKundhandelsetyper.current)
            fetchKundhandelsetyper()

        if (!fetchingProducentarendetyp.current && !fetchedProducentarendetyp.current)
            fetchProducentarendetyp()

        if (fetchedProducentarendetyp.current && (!fetchedOtherProducentarendetyper.current && !fetchingOtherProducentarendetyper.current)) {
            fetchOtherProducentarendetyper()
        }
    }

    const tableData = useMemo(() => {
        return kundhandelsetyper.map((kh: Kundhandelsetyp) => {
            return {
                id: kh.dbId,
                namn: kh.namn,
                rubrik: kh.rubrik,
                beskrivning: kh.beskrivning,
                kundhandelsetyp: kh
            }
        })
    }, [kundhandelsetyper])

    interface IRowExpander {
        row: any
    }
    const columns = useMemo(() => [
        {
            id: 'icon',
            Cell: (input: IRowExpander) => {
                const kh: Kundhandelsetyp = input.row.original.kundhandelsetyp
                return (
                    <span>{kh.producentarendetKlart ?
                        <CheckCircle color="blue"/> :
                        (kh.producentarendetKraverKundatgard ?
                            <ExclamationCircle color="red"/> :
                            null)}
                    </span>
                )
            }
        },
        {
            id: 'namn',
            Header: 'Namn',
            accessor: 'namn',
        },
        {
            id: 'rubrik',
            Header: 'Rubrik',
            accessor: 'rubrik',
        },
        {
            id: 'beskrivning',
            Header: 'Beskrivning',
            accessor: 'beskrivning',
        },
        {
            id: 'expander',
            Cell: (input: IRowExpander) => {
                const row = input.row
                return (
                    <span {...row.getToggleRowExpandedProps()}>
                        {row.isExpanded ? <ChevronUp /> : <ChevronDown />}
                    </span>
                )
            }
        }
    ], [])

    const tableInstance = useTable({columns: columns, data: tableData}, useExpanded)

    const getStyleForRadioTexts = (isList: boolean): string => {
        let ret = "col-md-3 text-center pointer"
        if (isList === showList)
            ret += " myselection"

        if (!isList && !producentarendetyp?.flowchartRef)
            ret += " disabled"

        return ret
    }

    const renderExpandedRow =
        (input: IRowExpander) => {
            const row = input.row
            return (
                <ShowKundhandelsetyp kundhandelsetyp={row.original.kundhandelsetyp}/>
            )
        }

    return (
        <div className="container-fluid">
            <div id="showProducentarendetyp-header" className="row">
                <div className="col-md-3">
                    <div className="heading">{producentarendetyp?.namn}</div>
                </div>
                <div className="col-md-9 container">
                    <div className="row">
                        <div className={getStyleForRadioTexts(true)} onClick={() => setShowList(true)}>Lista</div>
                        <div className={getStyleForRadioTexts(false)} onClick={() => setShowList(false)}>Flödesschema</div>
                        <div className="col-md-6">
                            <BackToStart />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    {otherProducentarendetyper.map((p: Producentarendetyp) => {
                        return (
                            <div
                                key={p.dbId}
                                className={ "producent-listing " + (
                                    p.dbId === producentarendetyp?.dbId ?
                                        (otherProducentarendetyper.length > 1 ? "myselection" : "") :
                                        "pointer") }
                                onClick={() => {
                                    if (p.dbId != producentarendetyp?.dbId) {
                                        navigate('/producentarendetyp/' + p.dbId)
                                        fetchedProducentarendetyp.current = false
                                        fetchingProducentarendetyp.current = false
                                        fetchedKundhandelsetyper.current = false
                                        fetchingKundhandelsetyper.current = false
                                    }
                                }}
                            >{p.producent.namn}</div>
                        )
                    })}
                </div>
                <div className="col-md-9">
                    { showList ?
                        <MyReactTable tableInstance={tableInstance} renderExpandedRow={renderExpandedRow} />:
                        <div>
                            <img src={ImageHandler.getImageByRef(producentarendetyp?.flowchartRef)} width="100%"/>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default ShowProducentarendetyp

